import {
  UsersIcon,
  ChartBarIcon,
  ArrowPathIcon,
  Squares2X2Icon,
  FunnelIcon,
  DocumentChartBarIcon,
  ClockIcon,
  ExclamationTriangleIcon,
  CreditCardIcon,
  CheckCircleIcon,
  GlobeAltIcon,
  PresentationChartLineIcon,
  QuestionMarkCircleIcon,
  TrophyIcon,
  ArrowsRightLeftIcon,
} from "@heroicons/react/24/outline";

export const REPORT_ICONS = {
  // ================= LEAD REPORTS =================
  totalLeads: UsersIcon,
  leadJourney: ArrowPathIcon,
  leadSource: FunnelIcon,
  leadCourse: DocumentChartBarIcon,

  // ================= APPLICATION REPORTS =================
  applicationStatus: ChartBarIcon,
  leadApplicantConversion: FunnelIcon,

  // ================= FOLLOW-UP REPORTS =================
  followupStatus: ClockIcon,
  overdueMissed: ExclamationTriangleIcon,

  // ================= PAYMENT REPORTS =================
  paymentLink: CreditCardIcon,
  paymentCompletion: CheckCircleIcon,


  // ================= PERFORMANCE =================
  counselorPerformance: PresentationChartLineIcon,

  // ================= QUERY =================
  queryStatus: QuestionMarkCircleIcon,
  leadAllocation: UsersIcon,
  salespersonPerformance: TrophyIcon,
  customComparison: ArrowsRightLeftIcon,
};